import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  updateProfile,
} from "firebase/auth"
import { FirebaseError } from "firebase/app"
import { AuthResult } from "./types"
import { updateUserProfile, storeUserData } from "./userManagement"

export const login = async (
  email: string,
  password: string
): Promise<AuthResult> => {
  try {
    const auth = getAuth()
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    )
    return {
      success: true,
      user: userCredential.user,
    }
  } catch (error: unknown) {
    const firebaseError = error as FirebaseError
    return {
      success: false,
      error: firebaseError.message || "Failed to login",
    }
  }
}

export const logout = async (): Promise<AuthResult> => {
  try {
    const auth = getAuth()
    await signOut(auth)
    return {
      success: true,
      message: "Logged out successfully",
    }
  } catch (error: unknown) {
    const firebaseError = error as FirebaseError
    return {
      success: false,
      error: firebaseError.message || "Failed to logout",
    }
  }
}

export const register = async (
  email: string,
  password: string
): Promise<AuthResult> => {
  try {
    const auth = getAuth()
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    )
    return {
      success: true,
      user: userCredential.user,
    }
  } catch (error: unknown) {
    const firebaseError = error as FirebaseError
    return {
      success: false,
      error: firebaseError.message || "Failed to register",
    }
  }
}

// Add the functions that Login.tsx is trying to import
export const loginWithEmailPassword = async (
  email: string,
  password: string
): Promise<AuthResult> => {
  return login(email, password)
}

export const registerWithEmailPassword = async (
  email: string,
  password: string,
  firstName: string,
  lastName: string
): Promise<AuthResult> => {
  try {
    const auth = getAuth()
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    )

    // Update the user's profile with their name
    await updateProfile(userCredential.user, {
      displayName: `${firstName} ${lastName}`,
    })

    // Store additional user data in Firestore
    await storeUserData(userCredential.user.uid, {
      email,
      firstName,
      lastName,
      displayName: `${firstName} ${lastName}`,
      createdAt: new Date(),
      updatedAt: new Date(),
      termsLastUpdated: new Date(),
    })

    return {
      success: true,
      user: userCredential.user,
    }
  } catch (error: unknown) {
    const firebaseError = error as FirebaseError
    return {
      success: false,
      error: firebaseError.message || "Failed to register",
    }
  }
}
